<template>
  <v-menu
    v-if="includeCsvDownloadOption"
    location="bottom right"
    :disabled="disabled"
  >
    <template #activator="{ props: activatorProps }">
      <DpplSvg
        data-png-ignore
        file-name="widget-download"
        class="widget-download"
        v-bind="{ ...activatorProps, ...$attrs }"
      />
    </template>
    <v-list density="compact">
      <v-list-item @click="disabled ? null : $emit('download-png')">
        <v-list-item-title>Download PNG</v-list-item-title>
      </v-list-item>
      <v-list-item @click="disabled ? null : $emit('download-csv')">
        <v-list-item-title>Download CSV</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <DpplSvg
    v-else
    data-png-ignore
    file-name="widget-download"
    class="widget-download"
    v-bind="$attrs"
    @click="disabled ? null : $emit('download-png')"
  />
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

defineProps({
  includeCsvDownloadOption: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['download-csv', 'download-png']);

</script>

<style lang="less" scoped>
.widget-download {
  cursor: pointer;

  :deep(path:first-child) {
    stroke: @grey-500;
  }

  :deep(path:last-child) {
    fill: @grey-500;
  }

  &:hover {
    :deep(path:first-child) {
      stroke: @grey-900;
    }

    :deep(path:last-child) {
      fill: @icon-darkest;
    }
  }
}

.menu-list-item.v-list-item {
  color: @text-darkest;
  border-bottom: 1px solid @stroke-default;
  min-height: 40px;
  height: 40px;
  white-space: nowrap;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
}

.menu-list-item.v-list-item:hover {
  background: @bg-canvas;
  cursor: pointer;

  > :deep(.v-list-item__overlay) {
    background: @bg-canvas;
  }
}

.v-menu > .v-overlay__content > .v-list {
  box-shadow: 0 10px 50px 0 fade(@grey-900, 10%);
  border-radius: 6px;
}
</style>
